import { render, staticRenderFns } from "./SavedInputLongNarratorFriendly.vue?vue&type=template&id=41d0fa7c&scoped=true&"
import script from "./SavedInputLongNarratorFriendly.vue?vue&type=script&lang=js&"
export * from "./SavedInputLongNarratorFriendly.vue?vue&type=script&lang=js&"
import style0 from "./SavedInputLongNarratorFriendly.vue?vue&type=style&index=0&id=41d0fa7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d0fa7c",
  null
  
)

export default component.exports